import React from "react";
import { Button, Col, Form, Row } from "antd";
import { useLoginStore } from "../../stores/useLoginStore";
import { Toaster } from "react-hot-toast";
import { useSubirDatos } from "../../hooks/adminexamen/useSubirDatos";
import { URL_PLANTILLA_EXCEL } from "../../api/url";

const SubirDatos = () => {
  const { onFinish, procesarArchivos, cargando } = useSubirDatos();

  return (
    <>
      <Row>
        <Col span={ 8 }></Col>
        <Col span={ 8 }>
          
          <a href={ URL_PLANTILLA_EXCEL } target='_blank'>Descargar</a>

          <form onSubmit={ onFinish } style={{ display: 'block', marginTop: 20 }}>
            <input type="file" onChange={ procesarArchivos }/>
            <br/>
            <br/>
            <Button type="primary" htmlType="submit" loading={ cargando }>
              Subir
            </Button>
          </form>

        </Col>
        <Col span={ 8 }></Col>
      </Row>

      <Toaster />
    </>
  );
};

export default SubirDatos;
